import styled from 'styled-components';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MoreVertIcon from '@mui/icons-material/MoreVert';

export const Container = styled.div`
  font-family: IBM Plex Sans;
  display: flex;
  justify-content: center;
  background-color: var(--white-pointer);
  // height:100%;
  height: 75vh;
  // overflow-y: scroll;
`;
export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 40px 100px 0px 100px;
  gap: 32px;
  height: 100%;
  overflow-y: scroll;
  @media (max-width: 1440px) {
    padding: 40px 60px 0px 60px;
  }
`;

export const StudentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SidebarContainer = styled.div`
  background-color: ${(props) => (props.open ? 'white' : 'transparent')};
  border-right: ${(props) =>
    props.open ? '1px solid rgba(201, 198, 204, 0.5)' : 'none'};
  border-top: ${(props) =>
    props.open ? '1px solid rgba(201, 198, 204, 0.5)' : 'none'};
  box-shadow: ${(props) =>
    props.open ? '-1px 4px 4px 0px rgba(115, 115, 115, 0.25)' : 'none'};
  width: ${(props) =>
    (props.open ? props.drawerWidth : props.collapsedWidth) + 'px'};
  transition: width 0.3s ease-in, background-color 0.2s ease-in,
    box-shadow 0.2s ease-in, border 0.2s ease-in;
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  left: ${(props) => (props.offset ?? 0) + 'px'};
  z-index: ${(props) => (props.elevated ? 20 : 5)};
  top: 70px;
  background-clip: padding-box;
  border-radius: 0;
`;

export const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const DrawerHeader = styled.div`
  height: 40px !important;
  display: grid;
  place-items: center;
  background: var(--light-mode-purple);
  padding: 8px 12px;
  border-radius: 32px;
  color: var(--white);
  margin: 8px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  font-weight: 500;
  line-height: 24px;
  position: relative;
  cursor: pointer;
  text-align: center;
`;

// width: ${props => (props.isOpen ? '300' : '200')};
//   /* width: 300px;  */
//   height: 100vh;
//   overflow-x: hidden; // Hide content when sidebar is collapsed
//   transition: width 0.3s; // Smooth transition for collapsing and expanding
//   background-color: #f0f0f0; // Example background color
//   position: fixed; // Needed for sticky positioning context
//   align-self: stretch;
//   top: 70px
//   overflow-y: scroll;

export const UserData = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const DropDownContainer = styled.div``;
export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 70%;
  height: 65vh;
`;
export const TextArea = styled.div`
  height: 43vh;
`;
export const FeedbackContainer = styled.div`
  width: 30%;
  padding: 20px;
  gap: 20px;
  background-color: white;
  height: 60vh;
`;
export const FeedbackButton = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 12px;
  gap: 8px;
  padding: 16px;
  background: linear-gradient(90deg, #7200e0 0%, #1b006b 98.63%);
  border: 1px solid #7200e0;
  color: white;
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ParaContainer = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: center;
`;

export const DrawerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 8px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const Heading = styled.p`
  font-size: var(--font-size-xl);
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 500;
  line-height: 26px;
  color: var(--text);
`;

export const DrawerInputBox = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid rgba(145, 139, 151, 1);
  border-radius: 8px;
`;

export const DrawerInput = styled.input`
  &::placeholder {
    color: rgba(151, 151, 151, 1);
  }
  padding: 6px 8px;
  width: 92%;
  border: none;
  border-radius: 8px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-l);
  line-height: 24px;
  font-weight: 400;
  color: rgba(151, 151, 151, 1);
  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.img`
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
`;

export const SubjectTitle = styled.p`
  font-size: 12px;
  line-height: 15.6px;
  font-weight: 500;
  font-family: var(--font-family-ibm_plex_sans);
  color: rgba(111, 111, 111, 1);
`;

export const DrawerSubjects = styled.div`
  display: flex;
  width: fit-content;
  flex-wrap: wrap;
  white-space: nowrap;
  gap: 8px;
  max-height: 20vh;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 0;
  }
`;
export const DrawerSubject = styled.div`
  padding: 8px 12px;
  background: ${(props) =>
    props.selected ? 'rgba(241, 230, 252, 1)' : 'white'};
  border: ${(props) =>
    props.selected
      ? '1px solid rgba(241, 230, 252, 1)'
      : '1px solid rgba(201, 198, 204, 0.5)'};
  color: ${(props) =>
    props.selected ? 'rgba(114, 0, 224, 1)' : 'rgba(123, 115, 130, 1)'};
  border-radius: 22px;
  cursor: pointer;
  font-family: 'IBM Plex Sans';
  font-size: 14px;
  line-height: 18.2px;
  font-weight: 600;
  &:hover {
    background: #e5c9ff;
    color: var(--royal-purple);
    border: 1px solid #ffefb5;
  }
`;

export const StyledMoreVertIcon = styled(MoreVertIcon)`
  font-size: 15px !important;
  width: 0 !important;
  transform: scaleX(0) !important;
  transition: transform 0.3s ease-in !important;
`;

export const RecentBtn = styled.div`
  padding: 8px 12px;
  border: 1px solid #dec7ff;
  background: var(--blue-chalk-2);
  border-radius: 22px;
  cursor: pointer;
  color: var(--light-mode-purple);
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: 600;
  font-size: 14px;
  line-height: 18.2px;
  display: flex;
  align-items: center;
  gap: 2px;

  &:hover {
    background: #fceaaa;
  }

  &:hover ${StyledMoreVertIcon} {
    width: auto !important;
    transform: scaleX(1) !important;
  }
`;

export const StyledAccessTimeIcon = styled(AccessTimeIcon)`
  font-size: 15px !important;
`;

export const DrawerQuestions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px !important;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  width: 100%;
  ::-webkit-scrollbar {
    width: 0;
  }
`;

// One line, always: a long name is cut with an ellipsis and the full name is
// the row's tooltip. The row never grows on hover, so the list keeps a fixed
// rhythm however long the questions get.
export const QuestionTitle = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// The actions button on the right of the name. Hidden until the row is hovered,
// focused, selected, or its menu is open, so a long list is not a column of dots.
export const DraftMenuButton = styled.button`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease;

  &:hover {
    background: rgba(114, 0, 224, 0.1);
  }
  &:focus-visible,
  &[aria-expanded='true'] {
    opacity: 1;
    outline: 2px solid var(--light-mode-purple);
    outline-offset: 1px;
  }
  &[aria-expanded='true'] {
    outline: none;
  }
`;

// Takes the name's place while a draft is being renamed.
export const DraftRenameInput = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  height: 22px;
  margin: -1px 0;
  padding: 0 6px;
  border: 1px solid var(--light-mode-purple);
  border-radius: 4px;
  background: var(--white);
  color: rgba(75, 70, 79, 1);
  font-family: inherit;
  font-size: inherit;
  line-height: 20px;
  outline: none;
`;

export const DrawerQuestion = styled.div`
  font-family: var(--font-family-ibm_plex_sans);
  font-weight: ${(props) => (props.studentStyle ? '500' : '400')};
  font-size: var(--font-size-s);
  line-height: 17px;
  padding: 12px;
  border-radius: 6px;
  background: ${(props) =>
    props.studentStyle ? 'rgba(241, 230, 252, 1)' : 'transparent'};
  color: ${(props) =>
    props.studentStyle ? 'rgba(114, 0, 224, 1)' : 'rgba(75, 70, 79, 1)'};
  position: relative;
  flex-shrink: 0;
  cursor: pointer;

  ${(props) =>
    props.studentStyle &&
    `
    ${DraftMenuButton} {
      opacity: 1;
    }
  `}

  &:hover ${DraftMenuButton},
  &:focus-within ${DraftMenuButton} {
    opacity: 1;
  }

  &:hover .tooltip-text {
    visibility: visible;
  }
`;

export const AvatarImg = styled.img`
  height: 30px;
  width: 30px;
  border-radius: 50%;
`;

export const DividerContainer = styled.div`
  margin: 0 10px;
`;

export const LoadingDiv = styled.div`
  padding: 20px 0;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: var(--font-size-xl);
  color: var(--text);
  font-weight: 500;
`;

export const TickBox = styled.div`
  position: absolute;
  top: 50%;
  right: 22px;
  transform: translateY(-50%);
`;

export const SidebarHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px 0 16px;
`;

export const SidebarIconButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e4d1ff;
  background: #f7eeff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: box-shadow 0.2s ease-in;

  &:hover {
    box-shadow: 0 4px 10px rgba(114, 0, 224, 0.2);
  }

  &:focus-visible {
    outline: 2px solid #7200e0;
    outline-offset: 2px;
  }
`;

export const CollapsedRail = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 16px 8px;
  border-radius: 0;
  border: 1px solid #e4d1ff;
  background: #ffffff;
  display: ${(props) => (props.open ? 'none' : 'flex')};
  flex-direction: column;
  align-items: center;
  gap: 12px;
  z-index: 6;
  box-shadow: 0 10px 30px rgba(25, 7, 57, 0.18);
`;

export const CollapsedRailButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: ${(props) => (props.variant === 'circle' ? '50%' : '12px')};
  border: ${(props) =>
    props.variant === 'circle' ? 'none' : '1px solid #e4d1ff'};
  background: ${(props) =>
    props.variant === 'circle'
      ? 'linear-gradient(135deg, #7200e0 0%, #4e00a0 100%)'
      : '#f1e6fc'};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${(props) =>
    props.variant === 'circle'
      ? '0 6px 18px rgba(82, 0, 160, 0.35)'
      : '0 3px 10px rgba(26, 4, 68, 0.15)'};

  &:hover {
    transform: translateY(-1px) scale(1.02);
  }

  &:focus-visible {
    outline: 2px solid #fde8ff;
    outline-offset: 2px;
  }
`;

export const SubjectFilterContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border: 1px solid #C9C6CC;
  border-radius: 10px;
  overflow: hidden;

  & > div {
    width: 100%;
  }

  & > div > div:first-of-type {
    border: none !important;
    box-shadow: none !important;
    background: #fff !important;
    width: 100%;
  }
`;

export const SubjectFilterSelect = styled.select`
  width: 100%;
  padding: 10px 36px 10px 16px;
  border: 1px solid #918B97;
  border-radius: 24px;
  font-family: var(--font-family-ibm_plex_sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #7B7382;
  background-color: #FFFFFF;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:focus {
    outline: none;
    border-color: #7200E0;
  }

  option {
    background-color: #FFFFFF;
    color: #7B7382;
    padding: 10px;
    font-family: var(--font-family-ibm_plex_sans);
    font-size: 14px;
  }
`;

export const SubjectFilterIcon = styled.img`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 10px;
  height: 10px;
`;

// The bulk-draft icon, the one-line name and the actions button share a row
// that never wraps.
export const DraftRowHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  width: 100%;
`;

export const DraftFileIcon = styled.img`
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
`;
